import './styles/virtual-table-row.scss'

type VirtualTableRowProps = {
  height?: number
  onClick?: () => void
}

export const VirtualTableRow = defineComponent<VirtualTableRowProps>({
  props: {
    height: {
      type: Number,
      default: 45,
    },
  },
  setup(props, { slots }) {
    return () => (
      <div
        class={'virtual-table-row'}
        style={{
          '--height': `${props.height}px`,
        }}
        onClick={props.onClick}
      >
        {slots.default?.()}
      </div>
    )
  },
})
